export function scaleImage(src,width,height){
	if(!src)return
	if(!width||!height)return src
	if(!src.match(/(jpg|png|jpeg)$/))return src
	return src.replace(/\/[^/]*jfs\//,`/s${width}x${height}_jfs/`)
}

export function scaleImageByZoom(src,zoom){
	if(!src)return
	if(zoom.match(/^(n0|s0|s2|s4|n1|s3|s5|n2|n3|n4|n5|n6|n7|n8|n9|n11|n12)$/)){
		src=src.replace('/eptjshop/','/'+zoom+'/').replace('/jshopimg/','/'+zoom+'/')
	}
	return src
}

export function cropImage(src,width,height,top,left){
	if(!src)return
	if(!width||!height||!top||!left)return src
	return src+`!cr_${width}x${height}_${top}_${left}`
}